import { B as BxfCardGroup$1, d as defineCustomElement$1 } from './p-df5d3605.js';

const BxfCardGroup = BxfCardGroup$1;
const defineCustomElement = defineCustomElement$1;

export { BxfCardGroup, defineCustomElement };
